/**
 * External webhook endpoints must be configured via env — never hardcode production URLs.
 * Client-side webhooks are a transitional pattern; proxy through a signed backend when possible.
 */

const N8N_BASE = (process.env.REACT_APP_N8N_WEBHOOK_BASE || "").replace(/\/$/, "");

export function isN8nWebhookConfigured() {
  return Boolean(N8N_BASE);
}

export function buildN8nWebhookUrl(path) {
  if (!N8N_BASE) {
    return null;
  }
  const normalized = String(path || "").replace(/^\//, "");
  return `${N8N_BASE}/${normalized}`;
}

export const WEBHOOK_PATHS = Object.freeze({
  INTAKE: "crewpilot-intake",
  FINALIZE_TIMELOG: "finalize-time-log",
  GET_QUESTION: "get-question",
  SUBMIT_ANSWER: "submit-answer",
});
